module.exports = __webpack_public_path__ + "static/img/logo_bugong.1c165c29.jpg";